export const flightMapper = (flightOriginalObject) => {
  // Return null if no flight object is provided
  if (!flightOriginalObject) {
    return null
  }

  // Deep object copy to prevent VueX mutation
  const flightObject = JSON.parse(JSON.stringify(flightOriginalObject))

  // Ensure segments array exists and has at least one element
  if (!flightObject?.segments || !Array.isArray(flightObject.segments) || flightObject.segments.length === 0) {
    return null
  }

  const supplierName = flightObject?.supplierName
  const supplierLogo = flightObject?.supplierLogo
  const uid = flightObject?.uid
  const fromSegment = flightObject.segments[0]
  const toSegment = flightObject.segments[flightObject.segments.length - 1]
  const flightClass = fromSegment?.class
  const durationInMinutes = flightObject.segments.reduce(
    (prev, cur) => prev + parseInt(cur?.duration || 0),
    0
  )

  const stops = []
  if (flightObject.segments.length > 1) {
    flightObject.segments.reduce((prev, cur) => {
      if (prev && cur) {
        stops.push({
          airport: prev.toAirport,
          arrivalDateTime: prev.arrivalDateAndTime,
          departureDateTime: cur.departureDateAndTime,
          duration: 0
        })
      }
      return cur
    })
  }

  return {
    from: {
      dateTime: fromSegment?.departureDateAndTime,
      airport: fromSegment?.fromAirport
    },
    to: {
      dateTime: toSegment?.arrivalDateAndTime,
      airport: toSegment?.toAirport
    },
    stops,
    price: flightObject?.price,
    supplierName,
    supplierLogo,
    flightClass,
    uid,
    durationInMinutes
  }
}
